export const publicPaths = [
  '/sign-in',
  '/sign-up',
  '/verify-email',
  '/accept-invitation',
  '/customer/accept-invitation',
  '/terms', // example of another public route
  '/privacy', // example of another public route
] as const;

export type PublicPath = (typeof publicPaths)[number];

export const isPublicPath = (path: string): boolean =>
  publicPaths.some((publicPath) => path === publicPath);
